import React, { useEffect } from 'react';
import styled from 'styled-components';
import randomColor from 'randomcolor';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import { useDispatch, useSelector } from 'react-redux';
import { Content } from '../../components/dashboard/Content';
import { Sidebar } from '../../components/dashboard/Sidebar';
import { _GetPost } from '../../store/actions/blogAction';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { loading, posts, error } = useSelector((state) => state.blog);

  const color = randomColor({
    count: 10,
    luminosity: 'light',
    hue: 'random',
  });

  useEffect(() => {
    dispatch(_GetPost());
  }, [dispatch]);

  return (
    <DashboardContainer>
      <div className='wrap'>
        <Sidebar />

        <Content>
          <PostContainer>
            {loading && <div>Loading...</div>}
            {error && <div>{error.error}</div>}
            {posts.blogs &&
              posts.blogs.length > 0 &&
              posts.blogs.map((post) => (
                <div key={post._id}>
                  {console.log(post.tags)}
                  <div className='contents'>
                    <div className='image'>
                      <img src={post.featuredImage} alt='featured_image' />
                    </div>
                    <div className='text'>
                      <h1>{post.title}</h1>

                      <Editor
                        editorState={
                          post
                            ? EditorState.createWithContent(
                                ContentState.createFromBlockArray(
                                  htmlToDraft(
                                    post.content.substring(0, 200) + '...'
                                  )
                                )
                              )
                            : EditorState.createEmpty()
                        }
                        readOnly
                        toolbarHidden
                      />

                      <div className='tags'>
                        {post.tags.map((ele, index) => {
                          return (
                            <ul key={index}>
                              <li
                                style={{
                                  background: `${
                                    index === 0
                                      ? color[0]
                                      : index === 1
                                      ? color[3]
                                      : index === 2
                                      ? color[2]
                                      : index === 3
                                      ? color[6]
                                      : index === 4
                                      ? color[9]
                                      : color[8]
                                  }`,
                                }}
                              >
                                {ele}
                              </li>
                            </ul>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </PostContainer>
        </Content>
      </div>
    </DashboardContainer>
  );
};

export const DashboardContainer = styled.main`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .wrap {
    width: 90%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
  }
`;

export const PostContainer = styled.div`
  .contents {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 14px auto;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  img {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 10px;
    margin: 10px;
    margin-top: 0;
    padding: 0;
  }

  .text {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .text h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0;
    padding: 0;
  }

  .tags {
    width: 100%;
    align-self: flex-end;
    position: relative;
    bottom: -20px;
  }

  .tags ul {
    display: inline-flex;
    flex-direction: row !important;
    justify-content: flex-start;
    text-align: center;
    text-transform: capitalize;
  }

  .tags ul li {
    margin: 5px;
    padding: 0;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 6px;
    padding: 6px 10px;
    list-style: none;
    color: ${({ theme }) => theme.dark};
    box-shadow: 0 5px 15px ${({ theme }) => theme.gradient};
  }

  pre {
    background: ${({ theme }) => theme.pale};
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export default Dashboard;
